import React from 'react'
import PropTypes from 'prop-types'
import { SessionStore } from '../../stores'
import { inject, observer } from 'mobx-react'
import IdleTimer from 'react-idle-timer'
import { SessionTimeoutModal } from './session-timeout-modal'
import { SessionMessage } from '../session-message'

@inject('sessionStore')
@observer
class SessionManager extends React.Component {
  constructor (props) {
    super(props)
    this.idleTimer = null
    this.onIdle = this.onIdle.bind(this)
    this.sessionTimeoutModalRef = React.createRef()
    const tenant = JSON.parse(window.sessionStorage.getItem('btp:tenant'))
    const userInfo = {
      Username: tenant?.name,
      UserId: tenant?.id
    }
    this.timeoutField = 1000 * 60 * 30
  }

  handleLogout = () => {
    this.props.router.push('/logout')
  }

  handleTimeout = () => {
    this.props.sessionStore.destroySessionWithMessage('Your session has been expired due to inactivity. Please log in again.')
  }

  resetIdle = () => {
    this.idleTimer.reset()
  }

  onIdle (e) {
    if (this.props.sessionStore.sessionMessageVisible === false) {
      this.sessionTimeoutModalRef.current.show()
    }
  }

  render () {
    return (
      <div>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          onIdle={this.onIdle}
          debounce={250}
          // timeout={this.timeoutField} // 15 minutes or 30 minutes based on idle time set.
        />
        <SessionMessage />
        <SessionTimeoutModal
          ref={this.sessionTimeoutModalRef}
          handleTimeout={this.handleTimeout}
          handleLogout={this.handleLogout}
          resetIdle={this.resetIdle}
        />
      </div>
    )
  }
}

SessionManager.propTypes = {
  router: PropTypes.object,
  sessionStore: PropTypes.instanceOf(SessionStore),
  env: PropTypes.object
}

export { SessionManager }